<template lang="html">
  <div v-bind:id="id">
    
    <div class="ui segment" v-for="(r, index) in rows" v-bind:key="r.id" >
        <component v-bind:is="r.type" v-bind:id="r.id" ></component>
    </div>

  </div >
</template>

<script>
export default {
  name: 'semanticRows',
  components: {
  },
  computed: {
    config: function() {
      return this.$store.getters.getObject(this.id).data;
    },
    rows() {
      return this.config.rows;
    }
  },
  props: {
    id: String,
    data: Object,
  },
  data() {
    return {
      showModal:false,
      components: [],
      idCopy: this.id,
    }
  },
  mounted: function() {
  },
  async created() {
  },
  methods: {
  }
}
</script>

<style scoped>
.rowspacer:not(:last-child) {
  margin-bottom: 0.5rem;
}

.lastComponent{
  margin-bottom: 11%;
}
</style>
